import React, {useEffect, useState} from 'react';

import AgentNoteTool from './AgentNoteTool';
import ShoppingCartTotals from './ShoppingCartTotals';
import CartSidebarButtonBox from './CartSidebarButtonBox';
import {affirmAvailableForTotal, refreshAffirm, safeRefreshAffirm} from "../../../lib/affirmHelpers";
import BraintreeClientProvider from "../../../Checkout/components/general/BraintreeClientProvider";
import FlatRateShippingLookAtMe from "./FlatRateShippingLookAtMe";

export default function CartSidebar(props) {
  const {currentAgent, shoppingCart = {}, braintreeData,
    onStartCheckout, cartConfig, callbacks} = props;
  const {effectiveTotal = 0, customerId} = shoppingCart;

  const [enableAffirm, setEnableAffirm] = useState(false);

  // Determine whether AFFIRM is available.
  // TODO: the child components should really figure this out on their own
  useEffect(() => {
    if (!effectiveTotal)
      return;

    const enabled = affirmAvailableForTotal(effectiveTotal, cartConfig)

    if (enabled !== enableAffirm)
      setEnableAffirm(enabled);
  }, [effectiveTotal]);

  return (
    <div id="cart-summary"
      className={customerId ? "saved-cart" : "unsaved-cart"}>

      <FlatRateShippingLookAtMe shoppingCart={shoppingCart} />

      <div id="cart-totals-container">
        {currentAgent?.id && <AgentSidebarTools
          currentAgent={currentAgent}
          shoppingCart={shoppingCart}
          callbacks={callbacks}
        />}

        <ShoppingCartTotals
          enableAffirm={enableAffirm}
          shoppingCart={shoppingCart}
          cartConfig={cartConfig}
        />
      </div>

      <BraintreeClientProvider braintreeData={braintreeData}
        render={btProps => <CartSidebarButtonBox
          onStartCheckout={onStartCheckout}
          enableAffirm={enableAffirm}


          {...props} {...btProps} />
        }
      />
    </div>
  );
}

/**
 * At top of sidebar - agent tools, revealed only if agent.
 *
 * @param props
 * @returns {JSX.Element|null}
 * @constructor
 */
function AgentSidebarTools({shoppingCart, currentAgent, callbacks}) {
  if (!currentAgent) return null;

  const {customerName, customerId} = shoppingCart;

  return <div>
    {customerName && <h4 className="agent-fg">{customerName}</h4>}

    <AgentNoteTool shoppingCart={shoppingCart} callbacks={callbacks} />
  </div>
}
